module.exports = __webpack_public_path__ + "static/keywordsDrawing-39c6756299d1624f267a4c85e27b2d85.png";